import { css } from '@emotion/css';

export const getEditorContainerStyles = ({ maxWidth = 61.6 }) => css`
  margin-top: 10%;
  margin-bottom: 10%;
  max-width: ${maxWidth}rem;
`;

export const addOptionStyles = css`
  height: 4.4rem;
`;
